import * as _ from "lodash";
import { Button, Grid, MenuItem, Typography } from "@mui/material";
import { Fragment, useRef, useState } from "react";

import { ComponentHeader, Paper, TextField } from "../../../components";
import { useAxios } from "../../../hooks";
import { useDispatch } from "react-redux";
import { alert } from "../../../redux/slices/alertSlice";
import { LoadingButton } from "@mui/lab";

export default function FormDisplay({
  resource,
  formikProps,
  editState,
  fields,
}) {
  const axios = useAxios();
  const dispatch = useDispatch();
  const inputRef = useRef(null);

  const [loader, setLoader] = useState(false);

  const [message, setMessage] = useState({});

  const handleParseJson = async (name) => {
    let value = _.get(formikProps.values, name);
    try {
      JSON.parse(value);
      setMessage({ ...message, [name]: "" });

      const parsedJson = JSON.parse(value);
      const formattedJson = JSON.stringify(parsedJson, null, 2);

      await formikProps.setValues((prev) => ({
        ...prev,
        [name]: formattedJson,
      }));
    } catch (e) {
      // Catch and handle JSON parsing errors
      if (e instanceof SyntaxError) {
        setMessage({
          ...message,
          [name]: "Invalid JSON format! Please check the syntax.",
        });
      } else {
        setMessage({
          ...message,
          [name]: "An unknown error occurred.",
        });
      }

      return;
    }
  };

  function handleResourceToken() {
    setLoader(true);
    axios({
      url: "/resources/generate-token",
      method: "POST",
      disableRedirect: true,
      data: {
        resource_id: formikProps.values.resourceID,
        payload: formikProps.values.sample_payload,
        headers: formikProps.values.headers,
        url: formikProps.values.url,
        method: formikProps.values.method,
      },
    }).then((res) => {
      if (res.status) {
        let response = res?.data?.response;
        if (res?.data?.status_code === 400) {
          dispatch(
            alert({
              type: "error",
              message: response.message,
            })
          );
          formikProps.setValues((prev) => ({
            ...prev,
            isTokenGenerated: false,
          }));
        } else {
          formikProps.setValues((prev) => ({
            ...prev,
            isTokenGenerated: true,
            generatedToken: {
              token_type: response.token_type,
              refresh_token: response.refresh_token,
              access_token: response.access_token,
              expires_in: response.expires_in,
            },
          }));

          dispatch(
            alert({
              type: "success",
              message:
                "Resource token generated successfully. Now you can save the resource",
            })
          );
        }
      }
      setLoader(false);
    });
  }

  return (
    <Fragment>
      <Paper>
        <Grid item xs={12}>
          <Typography variant="h5">Add Resource Details</Typography>
        </Grid>

        <Grid item xs={6}>
          <TextField
            required
            name="resourceName"
            label="Resource Name"
            formikProps={formikProps}
            disabled={!editState}
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            required
            name="resourceDescription"
            label="Resource Description"
            formikProps={formikProps}
            disabled={!editState}
          />
        </Grid>
      </Paper>

      {!formikProps.values?.isTokenGenerated && (
        <Paper>
          <Grid item xs={12}>
            <ComponentHeader
              title={"Generate Token"}
              subtitle={"Lets generate token for using the resource"}
              buttons={[
                <LoadingButton
                  loading={loader}
                  variant="outlined"
                  disabled={handleVal()}
                  onClick={() => {
                    handleResourceToken();
                  }}
                >
                  Generate Token
                </LoadingButton>,
              ]}
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              required
              name="url"
              label="Webhook URL"
              formikProps={formikProps}
              disabled={!editState}
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              required
              select
              name="method"
              label="Webhook Method"
              formikProps={formikProps}
              disabled={!editState}
            >
              <MenuItem value="get">GET</MenuItem>
              <MenuItem value="post">POST</MenuItem>
              <MenuItem value="put">PUT</MenuItem>
              <MenuItem value="patch">PATCH</MenuItem>
              <MenuItem value="delete">DELETE</MenuItem>
              <MenuItem value="options">OPTIONS</MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={12}>
            <Typography style={{ fontSize: "16px", fontWeight: "500" }}>
              Add Headers
            </Typography>
          </Grid>

          <Grid item xs={8}>
            {formikProps.values?.headers && editState && (
              <Button
                style={{
                  float: "right",
                  cursor: "pointer",
                  padding: "0 4px",
                  margin: "4px 0",
                }}
                variant="outlined"
                onClick={() => handleParseJson("headers")}
              >
                {" "}
                Beautify JSON
              </Button>
            )}

            <TextField
              multiline
              required
              name="headers"
              label="Add Authorization"
              formikProps={formikProps}
              disabled={!editState}
            />

            <Typography variant="body1" color="red">
              {message?.["headers"]}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography style={{ fontSize: "16px", fontWeight: "500" }}>
              Add Payload
            </Typography>
          </Grid>

          <Grid item xs={8}>
            {formikProps.values.sample_payload && editState && (
              <Button
                style={{
                  padding: "0 4px",
                  margin: "4px 0",
                  float: "right",
                  cursor: "pointer",
                }}
                variant="outlined"
                onClick={() => handleParseJson("sample_payload")}
              >
                {" "}
                Beautify JSON
              </Button>
            )}

            <TextField
              required
              ref={inputRef}
              label="Sample Payload"
              disabled={!editState}
              value={formikProps.values.sample_payload}
              onChange={(e) => {
                formikProps.setValues((prev) => ({
                  ...prev,
                  sample_payload: e.target.value,
                }));
              }}
              placeholder="Paste your raw JSON here..."
              multiline
            />
          </Grid>
        </Paper>
      )}
    </Fragment>
  );

  function handleVal() {
    if (
      formikProps.values.url &&
      formikProps.values.method &&
      formikProps.values.headers &&
      formikProps.values.sample_payload
    ) {
      return false;
    }

    return true;
  }
}
